export default {
  sign_up: "Sign Up",
  sign_in: "Sign In",
  logout: "Logout",
};
